import { useBlocker } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useBoundStore } from '@Store/useBoundStore';
import { NonUSSocurePageLayout } from '@Pages/happyFlowPages/NonUsSocure/NonUSSocurePage';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { useAuthUserDocVLogic } from './hooks/useAuthUserDocVLogic';

export const AuthUserDocVPage = () => {
  const { t } = useTranslation('inviteTeamMember');

  useBlocker({
    shouldBlockFn: ({ next }) => {
      const allowedRoutes: string[] = [
        routesModel[RoutesMap.INVITE_TEAM_MEMBER_FINISHED].path,
        routesModel[RoutesMap.VERIFICATION_FAILED].path,
        routesModel[RoutesMap.UNDER_REVIEW].path,
      ];
      return !allowedRoutes.includes(next.routeId);
    },
  });

  const docVData = useBoundStore((state) => state.authOnboardingSlice.docVData);
  const logic = useAuthUserDocVLogic();

  const socureData = {
    url: docVData?.url,
    qrCode: docVData?.qrCode,
  };

  return (
    <NonUSSocurePageLayout
      socureData={socureData}
      logic={logic}
      skipDefaultPolling={true}
      customDescription={t('authUserDocV.description')}
    />
  );
};
